import * as S from './CheckAvailabilityAltAcco.styles';

const CheckAvailabilityBtnUI = ({handlOpenCalendar = () => {}}) => {
  const onclickCheckAvailability = () => {
    handlOpenCalendar();
  };
  return (
    <S.CheckAvailabilityBtn onClick={onclickCheckAvailability}>
      Check Availability
    </S.CheckAvailabilityBtn>
  );
};

export default CheckAvailabilityBtnUI;
